import * as React from 'react';

type Props = {
    json: string;
}

export default class JsonPretty extends React.PureComponent<Props> {

    public render() {
        try {
          return <pre
              className="json-pretty"
              dangerouslySetInnerHTML={{ __html: this.pretty(JSON.parse(this.props.json)) }} />;
        } catch (e) {
          return <pre className="json-pretty">{this.props.json}</pre>;
        }
    }

    private _replace(_match: string, ind: any, key: any, val: any, tra: any) {
        const spanEnd = '</span>';
        const keySpan = '<span class=json-key>';
        const valSpan = '<span class=json-value>';
        const strSpan = '<span class=json-string>';
        const booSpan = '<span class=json-boolean>';
        let sps = ind || '';
        if (key) {
          sps = sps + '"' + keySpan + key.replace(/^"|":\s$/g, '') + spanEnd + '": ';
        }

        if (val) {
          if (val === 'true' || val === 'false') {
            sps = sps + booSpan + val + spanEnd;
          } else {
            sps = sps + (val[0] === '"' ? strSpan : valSpan) + val + spanEnd;
          }
        }

        return sps + (tra || '');
    }

    private pretty(obj: string) {
        const regLine = /^( *)("[^"]+": )?("[^"]*"|[\w.+-]*)?([,[{]|\[\s*\],?|\{\s*\},?)?$/mg;
        const text = JSON.stringify(obj, null, 2);

        if (!text) {
          return text;
        }

        return text
            .replace(/&/g, '&amp;')
            .replace(/\\"([^,])/g, '&quot;$1')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(regLine, this._replace);
    }
}
